import { createFileRoute } from "@tanstack/react-router";

import { ContactsForm } from "@/features/contacts/ui/contacts-form.tsx";
import { useContacts } from "@/features/contacts/use-contacts.ts";
import { PageLayout } from "@/shared/components/page-layout.ui.tsx";

export const Route = createFileRoute("/dashboard/contacts")({
  component: RouteComponent,
});

function RouteComponent() {
  // Форма создаётся уже с загруженными значениями, поэтому монтируем её
  // только после ответа сервера — иначе поля останутся пустыми.
  const { isFetched } = useContacts();

  return (
    <PageLayout title="Контакты">
      <p className="px-4 pb-2 text-sm text-default-500">
        Эти данные показывает мобильное приложение на экране поддержки.
        Изменения видны сразу после сохранения, без обновления приложения.
      </p>

      {isFetched && <ContactsForm />}
    </PageLayout>
  );
}
